(() => {
    class SwitchCallCenterRolesModalController {
        constructor(
            $scope,
            $uibModalInstance,
            currentCallCenterName,
            otherCallCenterNames,
            proceed
        ) {
            this._scope = $scope;
            this._modalInstance = $uibModalInstance;
            this._continueEventHandler = proceed;
            $scope.currentCallCenterName = currentCallCenterName;
            $scope.otherCallCenterNames = otherCallCenterNames;
            this.prepareScopeBindings();
        }

        prepareScopeBindings() {
            this._scope.continueClicked = this.continue.bind(this);
            this._scope.cancelClicked = this.cancel.bind(this);
        }

        continue() {
            this._continueEventHandler();
            this._modalInstance.close();
        }

        cancel() {
            this._modalInstance.close();
        }
    }

    angular.module("dashboard")
        .controller("SwitchCallCenterRolesModalController", [
            "$scope",
            "$uibModalInstance",
            "currentCallCenterName",
            "otherCallCenterNames",
            "proceed",
            SwitchCallCenterRolesModalController
        ]);
})();
